import { valuesDefaults } from './values';

export default {
    isVisible: false,
    values: valuesDefaults,
};
